import type { FieldIconName } from '../../constants/fieldIcons';

// gloss
export type SegmentFieldDecor = { label?: string; icon?: FieldIconName; hidden?: boolean; order?: number };

// gloss
export const SEGMENT_FIELD_DECOR: Readonly<Record<string, SegmentFieldDecor>> = {
  'FanUsers.email': { label: 'Email', icon: 'mail' },
  'FanUsers.firstName': { label: 'First name', icon: 'user' },
  'FanUsers.lastName': { label: 'Last name', icon: 'user' },
  'FanUsers.jobTitle': { label: 'Job title', icon: 'briefcase' },
  'FanUsers.companyDomain': { label: 'Company domain', icon: 'building' },
  'FanUsers.phoneNumber': { label: 'Phone number', icon: 'phone' },
  'FanUsers.pointsAmount': { label: 'Spendable Points (Current Balance)', icon: 'coins' },
  'FanUsers.lifetimePointsEarned': { label: 'Lifetime Points Earned', icon: 'coins' },
  'FanUsers.tierID': { label: 'Tier', icon: 'award' },
  'FanUsers.referenceOptIn': { label: 'Reference Opt-In', icon: 'shield-check' },
  'FanUsers.joinSource': { label: 'How They Joined', icon: 'tag' },
  'FanUsers.verifiedAt': { label: 'First Verified Sign-In', icon: 'shield-check' },
  'FanUsers.lastLoginAt': { label: 'Last Login', icon: 'clock' },
  'FanUsers.isInternal': { label: 'Internal', icon: 'users' },
  'FanUsers.advocateStatus': { label: 'Advocate Status', icon: 'activity' },
  'FanUsers.createdAt': { label: 'Advocate Join Date', icon: 'calendar' },
  'FanMissions.isApproved': { label: 'Approved', icon: 'circle-check' },
  'FanMissions.status': { label: 'Status', icon: 'activity' },
  'FanMissions.createdAt': { label: 'Date', icon: 'calendar' },
  'FanMissions.rewardValue': { label: 'Reward value', icon: 'gift' },
  'BrandMissions.uuid': { label: 'Mission', icon: 'target', hidden: true },
  'BrandMissions.missionName': { label: 'Mission name', icon: 'target' },
  'MissionTypes.missionTypeName': { label: 'Mission type', icon: 'tag' },
  // why: the rule stores the tag's uuid and the surface resolves it to the tag name, so the column
  // why: reads as "Tag" rather than leaking the identity it is built on (ZLT-4825).
  'BrandMissionTags.uuid': { label: 'Tag', icon: 'tag' },
  'FanRewards.redeemedUsdCents': { label: 'Redeemed value (cents)', icon: 'gift' },
  'FanRewards.status': { label: 'Status', icon: 'activity' },
  'FanRewards.pointsSpent': { label: 'Points spent', icon: 'coins' },
  'FanRewards.createdAt': { label: 'Date', icon: 'calendar' },
  'FanRunningStats.pointsCount': { label: 'Points earned', icon: 'coins' },
  'FanRunningStats.source': { label: 'Source', icon: 'database' },
  'FanRunningStats.reason': { label: 'Reason', icon: 'message-square' },
  'FanRunningStats.createdAt': { label: 'Date', icon: 'calendar' },
  'FanBadges.earnedAt': { label: 'Date earned', icon: 'calendar' },
  'FanBadges.brandBadgeUuid': { label: 'Badge', icon: 'award', hidden: true },
  'BrandBadges.badgeTitle': { label: 'Badge name', icon: 'award' },
  'Groups.uuid': { label: 'Segment', icon: 'users', hidden: true },
  'FanUserEnrichment.value': { label: 'Value', icon: 'tag', order: 1 },
  'FanUserEnrichment.valueNumber': { label: 'Value (number)', icon: 'tag', order: 2 },
  'FanUserEnrichment.valueDate': { label: 'Value (date)', icon: 'calendar', order: 3 },
  'FanUserEnrichment.sourceUpdatedAt': { label: 'Last updated', icon: 'clock', order: 4 },
  'IntegrationMap.uuid': { label: 'Field mapping', hidden: true },
  'IntegrationSource.uuid': { label: 'Data source', hidden: true },
  'ManualEngagements.activityType': { label: 'Activity type', icon: 'activity' },
  'ManualEngagements.activityDate': { label: 'Activity date', icon: 'calendar' },
  'ManualEngagements.pointsAwarded': { label: 'Points awarded', icon: 'coins' },
  'FanApplications.value': { label: 'Application answer', icon: 'file-text', order: 1 },
  'BrandApplicationForm.uuid': { label: 'Application question', icon: 'circle-help', hidden: true },
  'BrandApplicationForm.fieldName': { label: 'Application question', icon: 'circle-help' },
  'SurveyAnswers.answer': { label: 'Survey answer', icon: 'message-square', order: 1 },
  'SurveyQuestions.uuid': { label: 'Survey question', icon: 'circle-help', hidden: true },
  'SurveyQuestions.question': { label: 'Survey question text', icon: 'circle-help', hidden: true },
};
